import { render, staticRenderFns } from "./unbind.vue?vue&type=template&id=affecfd8&scoped=true&lang=pug&"
import script from "./unbind.vue?vue&type=script&lang=js&"
export * from "./unbind.vue?vue&type=script&lang=js&"
import style0 from "./unbind.vue?vue&type=style&index=0&id=affecfd8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "affecfd8",
  null
  
)

export default component.exports